function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "_100---Chocolate",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.597,26.072c0.692,-1.44 0.086,-3.169 -1.355,-3.861c-3.817,-1.834 -10.885,-5.23 -14.702,-7.064c-1.44,-0.692 -3.169,-0.085 -3.861,1.355c-2.676,5.571 -8.712,18.133 -8.712,18.133l19.917,9.57c0,0 6.036,-12.562 8.713,-18.133Z",
    style: {
      fill: "none",
      stroke: "#444f58",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.196,47.958c-0.619,1.287 -2.084,1.93 -3.451,1.514c-4.209,-1.282 -12.98,-3.954 -17.73,-5.401c-0.807,-0.246 -1.467,-0.832 -1.806,-1.605c-0.339,-0.772 -0.324,-1.655 0.041,-2.415c0.812,-1.691 1.77,-3.684 2.332,-4.853c0.127,-0.265 0.354,-0.468 0.631,-0.565c0.277,-0.098 0.582,-0.081 0.846,0.046c3.629,1.744 16.104,7.738 19.733,9.482c0.265,0.127 0.468,0.354 0.565,0.631c0.097,0.277 0.081,0.581 -0.047,0.846c-0.31,0.646 -0.727,1.514 -1.114,2.32Z",
    style: {
      fill: "none",
      stroke: "#444f58",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.752,49.564l-3.743,7.791c-0.515,1.072 -1.729,1.558 -2.712,1.086c-3.625,-1.741 -11.829,-5.683 -15.454,-7.425c-0.983,-0.472 -1.362,-1.724 -0.847,-2.796l2.529,-5.262",
    style: {
      fill: "none",
      stroke: "#444f58",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.871,21.987c0.212,-0.442 0.026,-0.972 -0.416,-1.184c-0.919,-0.442 -2.419,-1.163 -3.338,-1.604c-0.442,-0.213 -0.972,-0.027 -1.185,0.415c-0.441,0.919 -1.162,2.419 -1.604,3.339c-0.212,0.441 -0.026,0.972 0.416,1.184c0.919,0.442 2.419,1.162 3.338,1.604c0.442,0.212 0.972,0.026 1.185,-0.416c0.441,-0.919 1.162,-2.419 1.604,-3.338Z",
    style: {
      fill: "none",
      stroke: "#444f58",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.759,26.258c0.213,-0.442 0.027,-0.972 -0.415,-1.184c-0.919,-0.442 -2.419,-1.163 -3.339,-1.605c-0.441,-0.212 -0.972,-0.026 -1.184,0.416c-0.441,0.919 -1.162,2.419 -1.604,3.339c-0.212,0.441 -0.026,0.971 0.416,1.184c0.919,0.441 2.419,1.162 3.338,1.604c0.442,0.212 0.972,0.026 1.184,-0.416c0.442,-0.919 1.163,-2.419 1.604,-3.338Z",
    style: {
      fill: "none",
      stroke: "#444f58",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.837,30.382c0.212,-0.442 0.026,-0.972 -0.416,-1.184c-0.919,-0.442 -2.419,-1.163 -3.338,-1.604c-0.442,-0.213 -0.972,-0.027 -1.184,0.415c-0.442,0.919 -1.163,2.419 -1.604,3.339c-0.213,0.441 -0.027,0.972 0.415,1.184c0.919,0.442 2.419,1.162 3.339,1.604c0.441,0.212 0.972,0.026 1.184,-0.416c0.442,-0.919 1.162,-2.419 1.604,-3.338Z",
    style: {
      fill: "none",
      stroke: "#444f58",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.726,34.653c0.212,-0.442 0.026,-0.972 -0.416,-1.184c-0.919,-0.442 -2.419,-1.163 -3.338,-1.604c-0.442,-0.213 -0.972,-0.027 -1.184,0.415c-0.442,0.919 -1.163,2.419 -1.605,3.339c-0.212,0.441 -0.026,0.972 0.416,0.972 0.416,1.184 -0.416,1.604 -3.338,1.604 -3.338Z",
    style: {
      fill: "none",
      stroke: "#444f58",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.785,30.13l-9.146,5.181c0,0 -6.869,-12.126 -9.916,-17.504c-0.788,-1.39 -0.299,-3.156 1.091,-3.943c3.685,-2.088 10.508,-5.953 14.193,-8.041c1.39,-0.787 3.155,-0.299 3.943,1.092c1.498,2.645 3.922,6.924 5.999,10.589",
    style: {
      fill: "none",
      stroke: "#444f58",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.251,29.866c-3.886,2.201 -7.771,4.402 -9.522,5.394c-0.256,0.145 -0.443,0.385 -0.522,0.668c-0.078,0.283 -0.041,0.586 0.104,0.841c0.353,0.624 0.828,1.462 1.269,2.239",
    style: {
      fill: "none",
      stroke: "#444f58",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.145,12.872c-0.242,-0.426 -0.092,-0.968 0.335,-1.209c0.887,-0.503 2.335,-1.323 3.222,-1.826c0.427,-0.241 0.968,-0.092 1.21,0.335c0.502,0.887 1.323,2.335 1.825,3.222c0.242,0.427 0.092,0.968 -0.334,1.21c-0.888,0.503 -2.335,1.323 -3.223,1.826c-0.426,0.241 -0.968,0.091 -1.209,-0.335c-0.503,-0.887 -1.323,-2.335 -1.826,-3.223Z",
    style: {
      fill: "none",
      stroke: "#444f58",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.564,17.733c-0.241,-0.426 -0.091,-0.968 0.335,-1.209c0.888,-0.503 2.335,-1.323 3.223,-1.826c0.426,-0.242 0.968,-0.092 1.209,0.335c0.503,0.887 1.323,2.335 1.826,3.222c0.242,0.427 0.092,0.968 -0.335,1.21c-0.887,0.503 -2.335,1.323 -3.222,1.826c-0.427,0.241 -0.968,0.091 -1.21,-0.335c-0.503,-0.887 -1.323,-2.335 -1.826,-3.223Z",
    style: {
      fill: "none",
      stroke: "#444f58",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.795,22.845c-0.378,-0.666 -0.771,-1.36 -1.059,-1.869c-0.242,-0.426 -0.092,-0.968 0.334,-1.209c0.888,-0.503 2.336,-1.323 3.223,-1.826c0.427,-0.242 0.968,-0.092 1.21,0.335c0.404,0.712 1.012,1.787 1.497,2.642",
    style: {
      fill: "none",
      stroke: "#444f58",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.155,25.837c-0.241,-0.426 -0.091,-0.968 0.335,-1.209c0.887,-0.503 2.335,-1.323 3.223,-1.826c0.426,-0.242 0.968,-0.092 1.209,0.335c0.503,0.887 1.323,2.335 1.826,3.222c0.242,0.427 0.092,0.968 -0.335,1.21c-0.887,0.502 -2.335,1.323 -3.222,1.825c-0.427,0.242 -0.968,0.092 -1.21,-0.334c-0.503,-0.888 -1.323,-2.336 -1.826,-3.223Z",
    style: {
      fill: "none",
      stroke: "#444f58",
      strokeWidth: 2
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnack);
export default __webpack_public_path__ + "static/media/snack.d4193cfe5a09b3dddd58d37565cdd67c.svg";
export { ForwardRef as ReactComponent };